async function mainUserHelper(Vue, options) {
  if (options.router) {
    const router = options.router;

    await router.beforeEach((to, from, next) => {
      if (!to.meta.middleware || !to.meta.middleware.includes('mainUser')) {
        return next();
      }
      if (options.store.getters.isLogged && options.store.getters.user.isMainUser) {
        return next();
      } else {
        return next({ name: 'home' });
      }
    });
  }
}

export default mainUserHelper;
